<template>
  <swiper
    ref="mySwiper"
    class="swiper"
    :options="swiperOption"
    @slideChangeTransitionEnd="onSlideChange"
    @slideChangeTransitionStart="checkSlide"
  >
    <swiper-slide class="demo-1" v-for="item in List" :key="item.imsrc">
      <b-img :src="item.imsrc" fluid class="slide-fluid" />
    </swiper-slide>
    <swiper-slide class="video-item">
      <video ref="video" id="video" controls preload class="slide-fluid">
        <source
          src="https://pioneerstore.oss-cn-hangzhou.aliyuncs.com/2019Pioneer.mp4"
          type="video/mp4"
        />
      </video>
    </swiper-slide>

    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
    <div class="swiper-scrollbar" slot="scrollbar"></div>
  </swiper>
</template>

<script>
/* eslint-disable no-console */
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: { swiper: directive },
  data() {
    return {
      List: [
        {
          imsrc: require("../../../static/Updatedimg/swiper-6.jpg"),
          color: "#10131e",
        },
        {
          imsrc: require("../../../static/Updatedimg/swiper-8.jpg"),
          color: "#0F131E",
        },
        {
          imsrc: require("../../../static/Updatedimg/swiper-7.jpg"),
          color: "#040000",
        },
        {
          imsrc: require("../../../static/Updatedimg/homeBanner.jpg"),
          color: "#011826",
        },
      ],
      video: undefined,
      swiperOption: {
        loop: true,
        autoplay: true,
        speed: 1000,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
          hide: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    onSlideChange() {
      if (
        document
          .getElementsByClassName("swiper-slide-active")[0]
          .classList.contains("video-item")
      ) {
        //   this.swiper.autoplay.stop();
        this.video = document.getElementsByClassName(
          "swiper-slide-active"
        )[0].children[0];
        this.video.play();
        this.swiper.autoplay.stop();
      }
    },
    checkSlide() {
      if (
        !document
          .getElementsByClassName("swiper-slide-active")[0]
          .classList.contains("video-item")
      ) {
        this.video && this.video.pause();
      }
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    // console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
  },
};
</script>

<style lang="scss">
.swiper {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #7c7c7c; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 30px; /* 设置按钮大小 */
}
.swiper-button-next,
.swiper-button-prev {
  outline: none;
}
.swiper-container-horizontal > .swiper-scrollbar {
  height: 10px;
}
.swiper-scrollbar-drag {
  background: linear-gradient(to right, #f0f2f0, rgb(15, 19, 30));
}
.slide-fluid {
  width: 100%;
  height: -webkit-fill-available !important;
}
@media screen and (max-width: 900px) {
  .slide-fluid {
    width: 100%;
    height: auto !important;
  }
}
</style>
